<template>
  <v-select
    :options="standards"
    @search="searchStandards"
    label="name"
    @input="emitStandards"
    :value="objects"
    multiple
    :placeholder="placeholder"
  >
    <template slot="no-options" slot-scope="option">
      <span>Type to search standards...</span>
      <div v-if="taggable">Press enter to confirm new standard</div>
    </template>

    <template slot="option" slot-scope="option">
      <span>{{ option.name }}</span>
      <div
        v-if="option.description"
        class="text-muted pb-1"
        style="line-height: 0.85rem;"
        v-html="option.description"
      ></div>
    </template>

    <!-- <template slot="selected-option" slot-scope="option">
			<span>{{display(option)}}</span>
    </template>-->
  </v-select>
</template>

<style scoped>
</style>

<script>
import ConfigService from "@/services/ConfigService";

export default {
  name: "ConfigStandardSearch",

  props: {
    value: true,
    placeholder: true,
    taggable: {
      type: Boolean,
      default: false
    }
  },

  components: {},

  data() {
    return {
      firstEmit: true,
      objects: [],
      standards: [],
      descs: {}
    };
  },
  created() {
    this.constructObjects();
  },
  watch: {
    value() {
      console.log("value changed ", value)
      this.constructObjects();
    }
  },
  computed: {},
  methods: {
	  
    constructObjects() {
      let objects = [];
      _.each(this.value, v => {
        let object = _.find(this.standards, { name: v });
        if (object) {
          objects.push(object);
        } else {
		  objects.push({ name: v });
        }
      });

      this.objects = objects;
    },
	isInStandards(v){
		let i
		for (i = 0; i < this.standards.length; i++) {
			console.log(this.standards[i].name ,v,this.standards[i].name == v)
			if (this.standards[i].name == v) {
				
				console.log("Found it tho",v)
				return true;
			}
		}
		return false;
	},
    searchStandards(search, loading) {
      loading(true);
      ConfigService.getStandards()
        .then(resp => {
          loading(false);
          this.standards = resp.data;
        })
        .catch(err => {
          loading(false);
          console.log(err);
          this.standards = [{ name: "Error loading standards" }];
        });
    },

    emitStandards(standards) {
      //On load, @input gets called with no value
      //We need to prevent this or else the modeled array gets cleared before we can use it
      if (this.firstEmit) {
        this.firstEmit = false;
        return;
      }

      let newValues = _.map(standards, "name");
      this.mergeValues(newValues);

      this.$emit("input", this.value);
    },

    //Value must be edited in place instead of a new array defined, or vue goes nuts
    //Very annoying, would be solved by vue-select 2.6's reduce prop but we don't have that here
    mergeValues(newValues) {
      let newValueMap = {};
      _.each(newValues, nv => {
        newValueMap[nv] = true;
      });

      let valueMap = {};
      let i = 0;
      console.log("merging : ",this.value)
      for (;;) {
        if (i >= this.value.length) break;

        let el = this.value[i];
        if (!newValueMap[el]) {
          this.value.splice(i, 1);
        } else {
          valueMap[el] = true;
          i++;
        }
      }

      _.each(newValues, nv => {
        if (!valueMap[nv]) {
          this.value.push(nv);
          valueMap[nv] = true;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ConfigStandardSearch.vue